module.exports = __webpack_public_path__ + "img/ogatev9.3acf0aa8.png";